export default {
  Excellent: 'Excellent',
  Good: 'Good',
  Error: 'Exception',
  ExcellentTip: 'No critical abnormal events occurred during the current time interval',
  GoodTip: 'A critical abnormal event occurred during the current time interval and has been recovered(For status alarms, it means Alarmed)',
  ErrorTip: 'A critical exception event occurred during the current time interval and was not processed',
  BranchExcellentTip: 'No gateway exception events occurred during the current time interval',
  BranchGoodTip: 'A gateway exception occurred during the current time interval and has been restored.',
  BranchErrorTip: 'An abnormal event occurred within the current time interval and has not been recovered.',
  Type: 'Monitoring Type',
  HealthStatus: 'Health status',
  Branch: 'Branch',
  Flow: 'Flow',
  Overview: 'Overview',
  BranchNums: 'Branch numbers',
  ConvergentBranchNum: 'Convergent Branch numbers',
  ServiceGateway: 'Gateway in service',
  ServiceErrorGateway: 'Gateway for service exceptions',
  ServiceHealthStatus: 'Recent 24-hour service health status',
  AlarmEvent: 'Alert event',
  BusinessIndicators: 'Recent 24-hour business key indicators',
  NetworkMonitor: 'Network Quality Monitoring',
  UpBandwidthPeak: 'Peak upstream bandwidth',
  DownBandwidthPeak: 'Peak downstream bandwidth',
  Delay: 'Delay',
  Jitter: 'Jitter',
  PacketLoss: 'Packet loss',
  BranchHealthStatus: 'Recent 24-hour branch health status',
  BranchFlowTop5: 'Recent 24-hour branch traffic（top5）',
  BusinessDataAnalysis: 'Business data analysis',
  CompareUP: 'Compare to 24 hours ago, data increased',
  CompareDown: 'Compare to 24 hours ago, data reduced',
  CompareUnchange: 'Compare to 24 hours ago, data remains the same',
  ServiceHealthTips1: 'Service Health will select key mid- to high-level alarm events for evaluation. If you have not set',
  LastHealthTips: ', please configure it first. After configuration, monitoring will be enabled and health assessment will be performed. You can click on the evaluation settings above to customize the evaluation dimensions.', // ServiceHealthTips1 + 告警配置 + ServiceHealthTips2 为一句
  BranchHealthTips1: 'The branch health status is the monitoring and evaluation of the branch service status. The health evaluation is based on the occurrence of gateway abnormalities within the current time interval. You can',
  BranchHealthTips2: 'Check the gateway exception log.',
  BandwidthRateCompareUP: 'Increase in maximum bandwidth utilization (i.e., the ratio of maximum upstream and downstream bandwidth usage to purchased bandwidth) compared to 24-hour-old data',
  BandwidthRateCompareDown: 'Decrease in maximum bandwidth utilization (i.e., the ratio of maximum upstream and downstream bandwidth usage to purchased bandwidth) compared to 24-hour-old data',
  BandwidthRateCompareUnchange: 'The maximum bandwidth utilization (i.e., the ratio of maximum upstream and downstream bandwidth usage to purchased bandwidth) remains unchanged compared to 24-hour-old data',
  BandwidthUsage: 'Maximum bandwidth usage',
  AlertSettingTips: 'You can click Custom to select events. The system will perform a health assessment based on the occurrence of key abnormal events in the selected monitoring events. Events that must have the monitoring alarm switch turned on can be added to the health assessment.',
  AlarmCheckBoxTips: 'Please set the alarm configuration and turn on the alarm switch',
  NoMonitorAlarm: 'No monitoring alarm is set',
}